import {
  CLEAR_NOTIFICATIONS,
  CREATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  NotificationClearAction,
  NotificationCreateAction,
  NotificationDeleteAction,
  RESET_REDUCER,
} from 'services/App/Notifications/types';

/* ACTION REDUCERS */
export const resetReducer = () => ({
  type: RESET_REDUCER,
});

/* Notifications */
export const addNotification = (notification: $TSFixMe) => ({
  type: CREATE_NOTIFICATION,
  notification,
});

export const addSuccessNotification = (
  message: NotificationCreateAction['notification']['message'],
  title: NotificationCreateAction['notification']['title'] = 'Success',
  action?: NotificationCreateAction['notification']['action'],
): NotificationCreateAction => ({
  type: CREATE_NOTIFICATION,

  notification: {
    message,
    type: 'success',
    title,
    action,
  },
});

export const addErrorNotification = (
  message: NotificationCreateAction['notification']['message'],
  title: NotificationCreateAction['notification']['title'] = 'Error',
  action?: NotificationCreateAction['notification']['action'],
): NotificationCreateAction => ({
  type: CREATE_NOTIFICATION,

  notification: {
    message,
    type: 'error',
    title,
    action,
  },
});

export const addInfoNotification = (
  message: NotificationCreateAction['notification']['message'],
  title: NotificationCreateAction['notification']['title'] = 'Info',
  action?: NotificationCreateAction['notification']['action'],
): NotificationCreateAction => ({
  type: CREATE_NOTIFICATION,

  notification: {
    message,
    type: 'info',
    title,
    action,
  },
});

export const deleteNotification = (id: string): NotificationDeleteAction => ({
  type: DELETE_NOTIFICATION,
  id,
});

export const clearNotification = (): NotificationClearAction => ({
  type: CLEAR_NOTIFICATIONS,
});
